// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4052) return "4052.www.js";
	if (chunkId === 6676) return "6676.www.js";
	if (chunkId === 5290) return "5290.www.js";
	// return url for filenames based on template
	return "" + chunkId + ".www.js";
};